import {urlChatID} from "@/utils/url.js";
export class queryKey {
    static settings = 'settings'

    // Chatbot
    static chatbotList = 'chatbot.list'
    static catalog = 'chatbot.catalog'
    static chatbotSummary = 'chatbot.summary'
    static chatbotSourcesFiles = () => {return `chatbot.sources.files-${urlChatID()}`}
    static chatbotSourcesLinks = () => {return `chatbot.sources.links-${urlChatID()}`}
    static chatbotSourcesTexts = () => {return `chatbot.sources.texts-${urlChatID()}`}
    static chatbotSourcesQuestions = () => {return `chatbot.sources.questions-${urlChatID()}`}
    static chatbotInterfaceSettings = 'chatbot.settings.interface'
    static chatbotLeads = () => {return `chatbot.leads-${urlChatID()}`}

    // Conversations
    static chatbotConversations = () => {return `chatbot.conversations-${urlChatID()}`}
    static chatbotConversationHistory = `chatbot.conversation.history`

    // Billing
    static balance = `billing.balance`
    static payments =`billing.payments`
    static partner =`billing.partner`

    // Models
    static modelsList = 'models.list'
    static modelsImageList = 'models.image.list'

    // Images
    static imagesGallery = `images.gallery`
    static imagesPublicGallery = `images.public_gallery`
}